import React, { useEffect } from "react";
import { audience, benefits, pricing } from "../data/landing";
import { initMetaPixel, trackInitiateCheckout, trackViewContent } from "../utils/tracking";
import { Marquee } from "../components/Marquee";
import { Hero } from "../components/Hero";
import { TomosCarousel } from "../components/TomosCarousel";
import { ComboSummary } from "../components/ComboSummary";
import { FeatureGrid } from "../components/FeatureGrid";
import { Testimonials } from "../components/Testimonials";
import { PaymentMethods } from "../components/PaymentMethods";
import { Faq } from "../components/Faq";
import { FloatingCta } from "../components/FloatingCta";
import { Footer } from "../components/Footer";
export function Landing() {
  useEffect(() => {
    initMetaPixel();
    trackViewContent(pricing.price);
  }, []);
  const handleCheckout = () => trackInitiateCheckout(pricing.price);
  return <div className="w-full min-h-screen" style={{
    background: "#04100F"
  }} data-id="element-177" data-mp="m6si8rf4722y">
      <Marquee data-id="element-178" data-mp="29s9glix9sz8" />
      <Hero onCheckout={handleCheckout} data-id="element-179" data-mp="2aacc103b5g4" />
      <main className="w" data-id="element-180" data-mp="2bbqwfgbea2l">
        <TomosCarousel data-id="element-181" data-mp="3tgbhjsxdj4tu" />
        <ComboSummary data-id="element-182" data-mp="3tg20wvy7ya0t" />
        <FeatureGrid kicker="BENEFÍCIOS PRINCIPAIS" title="Mais tempo para o paciente, menos tempo planejando" subtitle="Tudo pensado para o dia a dia de quem atende idosos em consultório, domicílio ou instituição." items={benefits} data-id="element-183" data-mp="3tfjwvd5beric" />
        <FeatureGrid kicker="PARA QUEM É" title="Feito para quem cuida do movimento do idoso" subtitle="Se você trabalha com pessoas 60+, esta coleção vira o seu material de referência." items={audience} data-id="element-184" data-mp="l0ru5ajdwgmp" />
        <Testimonials data-id="element-185" data-mp="c5va1my4ljk2" />
        <PaymentMethods data-id="element-186" data-mp="79d9z0dqq9e2" />
        <Faq data-id="element-187" data-mp="782670kap1my" />
      </main>
      <Footer data-id="element-188" data-mp="78v3laxd6esf" />
      <FloatingCta onCheckout={handleCheckout} data-id="element-189" data-mp="77aj6e4rkc8a" />
    </div>;
}